<ng-container *ngIf="state?.pending?.reload">
    <cmps-wait-status></cmps-wait-status>
</ng-container>

<ng-container
    *ngIf="
        !state?.pending?.reload &&
        (state?.rows == null || state?.rows?.length === 0)
    "
>
    <div class="text-center">
        {{ _i18n._9866_NO_MI2_DATA_AVAILABLE | translate }}
    </div>
</ng-container>

<ng-container *ngIf="!state?.pending?.reload && state?.rows?.length > 0">
    <div class="cmps-mi2-main--categories">
        <div
            class="cmps-mi2-main--category"
            *ngFor="let cat of state?.categories"
        >
            <div class="cmps-mi2-main--category--info">
                <div class="cmps-mi2-main--category--info-num">
                    <button
                        class="cmps-mi2-main--category--info-name-button"
                        (click)="_onToggleFilterCategoryClick(cat)"
                    >
                        {{ cat?.scorecardImprovementCategoryName }}
                    </button>
                    <div class="cmps-mi2-main--category--info-num-performers">
                        {{ cat?.numPerformers }}
                        <cmps-icon svgIcon="account"></cmps-icon>
                    </div>
                </div>
                <div class="cmps-mi2-main--category--info-groups">
                    <div
                        class="cmps-mi2-main--category--group"
                        *ngFor="let grp of cat?.groups"
                    >
                        <div class="cmps-mi2-main--category--group-item-num">
                            <button
                                class="cmps-mi2-main--category--info-num-button"
                                [style.background-color]="grp?.colour"
                                (click)="_onToggleFilterGroupClick(grp)"
                            >
                                <span>{{ grp?.numPerformers }}</span>
                                <cmps-icon svgIcon="account"></cmps-icon>
                            </button>
                        </div>
                        <div
                            class="cmps-mi2-main--category--group-item-percent"
                        >
                            {{
                                grp?.performersWithScorePercent
                                    | cmpsPercent: '1.2-2'
                            }}
                        </div>
                        <div class="cmps-mi2-main--category--group-item-text">
                            {{ grp?.scorecardImprovementGroupName }}
                        </div>
                    </div>
                </div>
                <div class="cmps-mi2-main--category--info-button">
                    <button
                        class="cmps-icon-button--no-bg cmps-icon-button--sm"
                        cmpsIconButton
                        (click)="_onShowPopulationGroupClick()"
                    >
                        <cmps-icon svgIcon="information"></cmps-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="cmps-mi2-main--bar">
        <div class="cmps-mi2-main--bar-filter">
            <button
                class="cmps-icon-button--no-bg cmps-mi2-main--filter-button"
                cmpsIconButton
                [cmpsOverlayTrigger]="filterTpl"
                placement="bottom-left"
            >
                <cmps-icon svgIcon="sort-variant"></cmps-icon>
                <span cmpsIconButtonLabel>{{
                    _i18n._7360_FILTER | translate
                }}</span>
            </button>
        </div>
        <div class="cmps-mi2-main--bar-dates">
            <div>
                <span>{{ _i18n._7460_CURRENT_PERIOD | translate }}</span>
                <span>
                    {{
                        state?.dates?.startDate == null
                            ? (_i18n._842_N_A | translate)
                            : (state?.dates?.startDate | cmpsDate: 'MMM d, y')
                    }}
                    &nbsp;-&nbsp;{{
                        state?.dates?.endDate == null
                            ? (_i18n._842_N_A | translate)
                            : (state?.dates?.endDate | cmpsDate: 'MMM d, y')
                    }}
                </span>
            </div>
            <div>
                <span>{{ _i18n._9881_PREVIOUS_PERIOD | translate }}</span>
                <span>
                    {{
                        state?.dates?.previousStartDate == null
                            ? (_i18n._842_N_A | translate)
                            : (state?.dates?.previousStartDate
                              | cmpsDate: 'MMM d, y')
                    }}
                    &nbsp;-&nbsp;{{
                        state?.dates?.previousEndDate == null
                            ? (_i18n._842_N_A | translate)
                            : (state?.dates?.previousEndDate
                              | cmpsDate: 'MMM d, y')
                    }}
                </span>
            </div>
            <div>
                <span>{{ _i18n._7313_LAST_UPDATE | translate }}</span>
                <span>{{
                    state?.dates?.createdOn == null
                        ? (_i18n._842_N_A | translate)
                        : (state?.dates?.createdOn
                          | cmpsDate: 'MMM d, y, h:mm a')
                }}</span>
            </div>
        </div>
        <div class="cmps-mi2-main--bar-score">
            <button
                class="cmps-mi2-main--category--info-num-button"
                [style.background-color]="
                    state?.noScoreCategory?.groups[0]?.colour
                "
                (click)="
                    _onToggleFilterGroupClick(state?.noScoreCategory?.groups[0])
                "
            >
                <span>{{
                    state?.noScoreCategory?.groups[0]?.numPerformers
                }}</span>
                <cmps-icon svgIcon="account"></cmps-icon>
            </button>
            <span class="cmps-mi2-main--category--info-no-score">
                {{
                    state?.noScoreCategory?.scorecardImprovementCategoryName
                        | translate
                }}
            </span>
        </div>
    </div>
    <div class="cmps-mi2-main--bar-filter-list">
        <cmps-chip-list>
            <ng-container
                *ngFor="let c of state?.previousPerformanceClassFilterItems"
            >
                <cmps-chip
                    variant="b"
                    [selectable]="false"
                    *ngIf="c?.selected"
                >
                    <span
                        >{{
                            c?.item.scorecardPerformanceClassName | translate
                        }}
                        ({{ _i18n._9796_PREVIOUS | translate }})</span
                    >
                    <button
                        class="cmps-icon-button--no-bg cmps-icon-button--sm cmps-icon-button--no-bg--white"
                        cmpsIconButton
                        [disabled]="c?.disabled"
                        (click)="_onToggleFilterButtonClick(c)"
                    >
                        <cmps-icon svgIcon="close"></cmps-icon>
                    </button>
                </cmps-chip>
            </ng-container>
            <ng-container
                *ngFor="let c of state?.currentPerformanceClassFilterItems"
            >
                <cmps-chip
                    variant="b"
                    [selectable]="false"
                    *ngIf="c?.selected"
                >
                    <span
                        >{{
                            c?.item.scorecardPerformanceClassName | translate
                        }}
                        ({{ _i18n._9589_CURRENT | translate }})</span
                    >
                    <button
                        class="cmps-icon-button--no-bg cmps-icon-button--sm cmps-icon-button--no-bg--white"
                        cmpsIconButton
                        [disabled]="c?.disabled"
                        (click)="_onToggleFilterButtonClick(c)"
                    >
                        <cmps-icon svgIcon="close"></cmps-icon>
                    </button>
                </cmps-chip>
            </ng-container>
            <ng-container *ngFor="let g of state?.improvementGroupFilterItems">
                <cmps-chip
                    variant="b"
                    [selectable]="false"
                    *ngIf="g?.selected"
                >
                    <span
                        >{{
                            g?.item.scorecardImprovementGroupName | translate
                        }}
                        ({{ _i18n._9860_IMPROVEMENT | translate }})</span
                    >
                    <button
                        class="cmps-icon-button--no-bg cmps-icon-button--sm cmps-icon-button--no-bg--white"
                        cmpsIconButton
                        [disabled]="g?.disabled"
                        (click)="_onToggleFilterButtonClick(g)"
                    >
                        <cmps-icon svgIcon="close"></cmps-icon>
                    </button>
                </cmps-chip>
            </ng-container>
        </cmps-chip-list>
    </div>

    <ng-template
        let-overlay="overlay"
        #filterTpl
    >
        <cmps-filter
            [overlay]="overlay"
            #filter
        >
            <cmps-filter-header-label
                >{{ _i18n._7360_FILTER | translate }}
            </cmps-filter-header-label>

            <cmps-filter-category-header>{{
                _i18n._9861_SELECT_A_PREVIOUS_SCORECARD_CATEGORY | translate
            }}</cmps-filter-category-header>
            <cmps-filter-category-body>
                <cmps-chip-list>
                    <ng-container
                        *ngFor="
                            let c of state?.previousPerformanceClassFilterItems
                        "
                    >
                        <button
                            cmpsChip
                            [value]="c?.item"
                            [selected]="c?.selected"
                            [disabled]="c?.disabled"
                        >
                            <span>{{
                                c?.item.scorecardPerformanceClassName
                                    | translate
                            }}</span>
                        </button>
                    </ng-container>
                </cmps-chip-list>
            </cmps-filter-category-body>

            <cmps-filter-category-header>{{
                _i18n._9862_SELECT_A_CURRENT_SCORECARD_CATEGORY | translate
            }}</cmps-filter-category-header>
            <cmps-filter-category-body>
                <ng-container
                    *ngFor="let c of state?.currentPerformanceClassFilterItems"
                >
                    <button
                        cmpsChip
                        [value]="c?.item"
                        [selected]="c?.selected"
                        [disabled]="c?.disabled"
                    >
                        <span>{{
                            c?.item.scorecardPerformanceClassName | translate
                        }}</span>
                    </button>
                </ng-container>
            </cmps-filter-category-body>

            <cmps-filter-category-header>{{
                _i18n._9863_SELECT_AN_IMPROVEMENT_CATEGORY | translate
            }}</cmps-filter-category-header>
            <cmps-filter-category-body>
                <ng-container
                    *ngFor="let g of state?.improvementGroupFilterItems"
                >
                    <button
                        cmpsChip
                        [value]="g?.item"
                        [selected]="g?.selected"
                        [disabled]="g?.disabled"
                    >
                        <span>{{
                            g.item.scorecardImprovementGroupName | translate
                        }}</span>
                    </button>
                </ng-container>
            </cmps-filter-category-body>

            <button
                class="w-100"
                cmpsButton
                [disabled]="!filter.selectionChanged"
                (click)="_onApplyFilterClick(filter.nextSelection)"
            >
                <span cmpsButtonLabel>{{
                    _i18n._9864_APPLY_FILTER | translate
                }}</span>
            </button>
        </cmps-filter>
    </ng-template>

    <cmps-mi2-table
        [data]="state?.rows"
        [altData]="state?.filteredRows"
        [sortOptions]="state?.sortOptions"
        [popupOpen]="
            state?.populationGroupDialogData != null ||
            state?.trendDialogData != null
        "
        (columnSortClick)="_onColumnSortClick($event.c)"
        (showTrendClick)="_onShowTrendClick($event.r, $event.key)"
    >
    </cmps-mi2-table>
</ng-container>
